import { Box, TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import CustomTabButton from "../../unit/CustomTabButton";
import CustomDetailBox from "./CustomDetailBox";
import CustomSummaryApplicationList from "./CustomSummaryApplicationList";
import CustomSummaryLoanList from "./CustomSummaryLoanList";
interface RecordType {
  applications?: {};
  paymentAccountData?: {};
  plaidAccountList?: {};
  adviceRequest?: {};
  plaidAccount?: {
    income_level: any;
    income_stability: any;
    spending_mix?: any;
    spending_within_means?: any;
    spending_stability?: any;
    savings_net_asset_mdb?: any;
    savings_net_asset_nsf?: any;
    savings_net_credit_mdb?: any;
    savings_net_safety?: any;
    financial_iq?: any;
    total_score?: any;
  };
}
const TableCellRight = styled(TableCell)({ textAlign: "right" });

const CustomSummaryTabList = ({ ...props }) => {
  const userId = props.userId;
  let record: RecordType = {};
  const [activeTab, setActiveTab] = React.useState(0);
  record = props.record;

  let plaidAccount: RecordType["plaidAccount"] =
    record && record.plaidAccount ? record.plaidAccount : undefined;
  let paymentAccountData: RecordType["paymentAccountData"] =
    record && record.paymentAccountData ? record.paymentAccountData : undefined;
  let plaidAccountList: RecordType["plaidAccountList"] =
    record && record.plaidAccountList ? record.plaidAccountList : undefined;
  let adviceRequest: RecordType["adviceRequest"] =
    record && record.adviceRequest ? record.adviceRequest : undefined;

  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <Box sx={{ width: "100%", pt: 0, height: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <CustomTabButton
          variant="text"
          onClick={() => handleChange(0)}
          className={activeTab === 0 ? "Mui-selected" : ""}
          id="btn-show-tab-applications"
        >
          Applications
        </CustomTabButton>
        <CustomTabButton
          variant="text"
          onClick={() => handleChange(1)}
          className={activeTab === 1 ? "Mui-selected" : ""}
          id="btn-show-tab-loans"
        >
          Loans
        </CustomTabButton>
      </Box>
      <CustomDetailBox
        sx={{
          display: activeTab === 0 ? "block" : "none",
        }}
      >
        <CustomSummaryApplicationList
          userId={userId}
          applications={record.applications}
        />
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 1 ? "block" : "none" }}>
        <CustomSummaryLoanList userId={userId} loans={record.loans} />
      </CustomDetailBox>
    </Box>
  );
};

export default CustomSummaryTabList;
